import React, { Component } from "react";
import './Music-List.css';
import MusicList from "./Music-List";
import { Link } from 'react-router-dom';
import PlaySongs from "./PlaySongs";
import axios from '../tokenInterceptor';

class MyMusic extends Component {
    constructor(props) {
        super(props);
        this.state={
            itemDescriptions:{},
            hide:false,
            musicPlaylists:[],
            musicArtists:[],
            musicAlbums:[],
            musicTracks:{
                "track_0_desc":{
                    "image":{}
                },
                "track_1_desc":{
                    "image":{}
                },
                "track_2_desc":{
                    "image":{}
                },
                "track_3_desc":{
                    "image":{}
                },
                "track_4_desc":{
                    "image":{}
                },
                "track_5_desc":{
                    "image":{}
                },
                "track_6_desc":{
                    "image":{}
                },
                "track_7_desc":{
                    "image":{}
                },
                "track_8_desc":{
                    "image":{}
                },
                "track_9_desc":{
                    "image":{}
                },
                "track_10_desc":{
                    "image":{}
                }

            },
            musicGenres:[],
            testPlaylist:[],
            selectedMusic:{},
            musicTracksPlayable_0:[],
            musicTracksPlayable_1:[],
            musicTracksPlayable_2:[],
            musicTracksPlayable_3:[],
            musicTracksPlayable_4:[],
            musicTracksPlayable_5:[],
            musicTracksPlayable_6:[],
            musicTracksPlayable_7:[],
            musicTracksPlayable_8:[],
            musicTracksPlayable_9:[],
            musicTracksPlayable_10:[],
        }
    }

    componentWillMount =()=>{
        this.checkTokenExpire();
    }

    getMyMusic=()=>{
        axios.get("/getMyMusic").then((res)=>{
            if(res.data.status == 200) {
                this.getMyMusicPlaylists();
                this.getMyMusicArtists();
                this.getMyMusicAlbums();
                this.getMyMusicTracks();
                this.getMyMusicGenres();
                this.setState({itemDescriptions:res.data.data.itemDescriptions, hide:true});
            } else {
                this.setState({itemDescriptions:{}})
            }
        })
    }

    getMyMusicPlaylists=()=>{
        axios.get("/getMyMusicPlaylists").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.itemDescriptions;
                let num = Object.keys(td).length;
                let topMusicPlaylists =[]
                for(let i=0; i<num; i++) {
                let key = "playlist_"+i+"_desc";
                let data = td[key];
                topMusicPlaylists.push(data);
                };
                this.getTestPlaylist();
                this.setState({musicPlaylists:topMusicPlaylists});
            } else {
                this.setState({musicPlaylists:[]})
            }
        })
    }

    getMyMusicArtists=()=>{
        axios.get("/getMyMusicArtists").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.itemDescriptions;
                let num = Object.keys(td).length;
                let topMusicArtists =[]
                for(let i=0; i<num; i++) {
                let key = "artist_item_"+i;
                let data = td[key];
                topMusicArtists.push(data);
                };
                this.setState({musicArtists:topMusicArtists});
            } else {
                this.setState({musicArtists:[]})
            }
        })
    }

    getMyMusicAlbums=()=>{
        axios.get("/getMyMusicAlbums").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.itemDescriptions;
                let num = Object.keys(td).length;
                let topMusicAlbum =[]
                for(let i=0; i<num; i++) {
                let key = "album_item_"+i;
                let data = td[key];
                topMusicAlbum.push(data);
                };
                this.setState({musicAlbums:topMusicAlbum});
            } else {
                this.setState({musicAlbums:[]})
            }
        })
    }

    getMyMusicTracks=()=>{
        axios.get("/getMyMusicTracks").then((res)=>{
            if(res.data.status == 200) {
                console.log("res.data.data.itemDescriptions==", res.data.data.itemDescriptions)
                var musicTracks = this.state.musicTracks;
                musicTracks = res.data.data.itemDescriptions;
                this.setState({musicTracks:musicTracks});
                this.getMyMusicTracksPlayable_0();
                this.getMyMusicTracksPlayable_1();
                this.getMyMusicTracksPlayable_2();
                this.getMyMusicTracksPlayable_3();
                this.getMyMusicTracksPlayable_4();
                this.getMyMusicTracksPlayable_5();
                this.getMyMusicTracksPlayable_6();
                this.getMyMusicTracksPlayable_7();
                this.getMyMusicTracksPlayable_8();
                this.getMyMusicTracksPlayable_9();
                this.getMyMusicTracksPlayable_10();
            } else {
                this.setState({musicTracks:{}})
            }
        })
    }

    getMyMusicGenres=()=>{
        axios.get("/getMyMusicGenres").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.itemDescriptions;
                let num = Object.keys(td).length;
                let topMusicGenres=[]
                for(let i=0; i<num; i++) {
                let key = "genre_item_"+i;
                let data = td[key];
                topMusicGenres.push(data);
                };
                this.setState({musicGenres:topMusicGenres});
            } else {
                this.setState({musicGenres:[]})
            }
        })
    }

    getTestPlaylist=()=>{
        axios.get("/getTestPlaylist").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let topTestPlaylist=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                topTestPlaylist.push(data);
                };
                this.setState({testPlaylist:topTestPlaylist});
            } else {
                this.setState({testPlaylist:[]})
            }
        })
    }

    getMyMusicTracksPlayable_0=()=>{
        axios.get("/getMyMusicTracksPlayable_0").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let musicTracksPlayableContent=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                musicTracksPlayableContent.push(data);
                };
                this.setState({musicTracksPlayable_0:musicTracksPlayableContent});
            } else {
                this.setState({musicTracksPlayable_0:[]})
            }
        })
    }

    getMyMusicTracksPlayable_1=()=>{
        axios.get("/getMyMusicTracksPlayable_1").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let musicTracksPlayable1Content=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                musicTracksPlayable1Content.push(data);
                };
                this.setState({musicTracksPlayable_1:musicTracksPlayable1Content});
            } else {
                this.setState({musicTracksPlayable_1:[]})
            }
        })
    }

    getMyMusicTracksPlayable_2=()=>{
        axios.get("/getMyMusicTracksPlayable_2").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let musicTracksPlayable_2Content=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                musicTracksPlayable_2Content.push(data);
                };
                this.setState({musicTracksPlayable_2:musicTracksPlayable_2Content});
            } else {
                this.setState({musicTracksPlayable_2:[]})
            }
        })
    }

    getMyMusicTracksPlayable_3=()=>{
        axios.get("/getMyMusicTracksPlayable_3").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let musicTracksPlayable_3Content=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                musicTracksPlayable_3Content.push(data);
                };
                this.setState({musicTracksPlayable_3:musicTracksPlayable_3Content});
            } else {
                this.setState({musicTracksPlayable_3:[]})
            }
        })
    }

    getMyMusicTracksPlayable_4=()=>{
        axios.get("/getMyMusicTracksPlayable_4").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let musicTracksPlayable_4Content=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                musicTracksPlayable_4Content.push(data);
                };
                this.setState({musicTracksPlayable_4:musicTracksPlayable_4Content});
            } else {
                this.setState({musicTracksPlayable_4:[]})
            }
        })
    }

    getMyMusicTracksPlayable_5=()=>{
        axios.get("/getMyMusicTracksPlayable_5").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let musicTracksPlayable_5Content=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                musicTracksPlayable_5Content.push(data);
                };
                this.setState({musicTracksPlayable_5:musicTracksPlayable_5Content});
            } else {
                this.setState({musicTracksPlayable_5:[]})
            }
        })
    }

    getMyMusicTracksPlayable_6=()=>{
        axios.get("/getMyMusicTracksPlayable_6").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let musicTracksPlayable_6Content=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                musicTracksPlayable_6Content.push(data);
                };
                this.setState({musicTracksPlayable_6:musicTracksPlayable_6Content});
            } else {
                this.setState({musicTracksPlayable_6:[]})
            }
        })
    }

    getMyMusicTracksPlayable_7=()=>{
        axios.get("/getMyMusicTracksPlayable_7").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let musicTracksPlayable_7Content=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                musicTracksPlayable_7Content.push(data);
                };
                this.setState({musicTracksPlayable_7:musicTracksPlayable_7Content});
            } else {
                this.setState({musicTracksPlayable_7:[]})
            }
        })
    }

    getMyMusicTracksPlayable_8=()=>{
        axios.get("/getMyMusicTracksPlayable_8").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let musicTracksPlayable_8Content=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                musicTracksPlayable_8Content.push(data);
                };
                this.setState({musicTracksPlayable_8:musicTracksPlayable_8Content});
            } else {
                this.setState({musicTracksPlayable_8:[]})
            }
        })
    }

    getMyMusicTracksPlayable_9=()=>{
        axios.get("/getMyMusicTracksPlayable_9").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let musicTracksPlayable_9Content=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                musicTracksPlayable_9Content.push(data);
                };
                this.setState({musicTracksPlayable_9:musicTracksPlayable_9Content});
            } else {
                this.setState({musicTracksPlayable_9:[]})
            }
        })
    }

    getMyMusicTracksPlayable_10=()=>{
        axios.get("/getMyMusicTracksPlayable_10").then((res)=>{
            if(res.data.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let musicTracksPlayable_10Content=[]
                for(let i=0; i<num; i++) {
                let key = "track_def_"+i;
                let data = td[key];
                musicTracksPlayable_10Content.push(data);
                };
                this.setState({musicTracksPlayable_10:musicTracksPlayable_10Content});
            } else {
                this.setState({musicTracksPlayable_10:[]})
            }
        })
    }

    setMusic=(data)=>{
        let selectedMusic= this.state.selectedMusic;
        selectedMusic.title = data.title;
        selectedMusic.artist = data.artist.name;
        selectedMusic.imageUrl = data.image.uri;
        selectedMusic.songUrl = data.audio.uri;
        this.setState({selectedMusic:selectedMusic});
    }

    generateNewAccessToken() {
        var requestObject = {
          "grant_type": "refresh_token",
          "refresh_token": localStorage.getItem("refresh_token"),
          "client_id": "amzn1.application-oa2-client.be6fd65f44a24c7dabec6f1e78c0fbd9",
          "client_secret": "9ceb5c037d0d032d62fd09e64b4784dfd06ec22cae72e15cb9b9e1690e3bfe05"
        };
        axios.post("generateToken", requestObject).then((res)=>{
            if(res.status ==200) {
                var currentTime   = new Date();
                this.tokenGetTime=  currentTime.getTime();
                localStorage.setItem('auth-token', res.data.data.access_token);
                localStorage.setItem('expire', 3600);
                localStorage.setItem('tokenFetchTime', this.tokenGetTime);
                localStorage.setItem('refresh_token', res.data.data.refresh_token);
                this.getMyMusic();
            } else {
                console.log("unable t generate token");
            }
        });
    }

    checkTokenExpire=()=>{
        var currentTime   = new Date();
        this.tokenGetTime=  localStorage.getItem('tokenFetchTime');
        if((currentTime.getTime() - this.tokenGetTime)/1000 < 3600) {
            this.getMyMusic();
        } else {
            this.generateNewAccessToken();
        }
    }

    render() {
        return (
            <>
                <div className="right-section">
                    <div className="main-page">
                        {
                            this.state.hide && (
                                <div className="top-playlist">
                                    <div className="top-songs">
                                        <h3 className="heading">{this.state.itemDescriptions.label_0_desc.itemLabel}</h3>
                                        <hr/>
                                        <ul>
                                            {this.state.musicPlaylists.map((data, index)=>{
                                                return <li key={index} className="song-title">
                                                    <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                    <a className="title">{data.itemLabel}</a>
                                                </li>
                                            })}
                                            <ul>
                                                {this.state.testPlaylist.map((data, index)=>{
                                                    return <li key={index} className="song-title">
                                                        <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                        <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                                    </li>
                                                })}
                                            </ul>
                                        </ul>
                                        
                                    </div>
                                    <hr/>
                                    <div className="top-songs">
                                        <h3 className="heading">{this.state.itemDescriptions.label_1_desc.itemLabel}</h3>
                                        <hr/>
                                        <ul>
                                            {this.state.musicArtists.map((data, index)=>{
                                                return <li key={index} className="song-title">
                                                    <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                    <a className="title">{data.itemLabel}</a>
                                                </li>
                                            })}
                                        </ul>
                                    </div>
                                    <hr/>
                                    <div className="top-songs">
                                        <h3 className="heading">{this.state.itemDescriptions.label_2_desc.itemLabel}</h3>
                                        <hr/>
                                        <ul>
                                            {this.state.musicAlbums.map((data, index)=>{
                                                return <li key={index} className="song-title">
                                                    <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                    <a className="title">{data.itemLabel}</a>
                                                </li>
                                            })}
                                        </ul>
                                    </div>
                                    <hr/>
                                    <div className="top-songs">
                                        <h3 className="heading">{this.state.itemDescriptions.label_3_desc.itemLabel}</h3>
                                        <hr/>
                                        <ul>
                                            <li className="song-title">
                                                <img src={this.state.musicTracks.track_0_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title">{this.state.musicTracks.track_0_desc.itemLabel}</a>
                                                <ul>
                                                    {this.state.musicTracksPlayable_0.map((data, index)=>{
                                                        return <li key={index} className="song-title">
                                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </li>
                                            <li className="song-title">
                                                <img src={this.state.musicTracks.track_1_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title">{this.state.musicTracks.track_1_desc.itemLabel}</a>
                                                <ul>
                                                    {this.state.musicTracksPlayable_1.map((data, index)=>{
                                                        return <li key={index} className="song-title">
                                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </li>
                                            <li className="song-title">
                                                <img src={this.state.musicTracks.track_2_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title">{this.state.musicTracks.track_2_desc.itemLabel}</a>
                                                <ul>
                                                    {this.state.musicTracksPlayable_2.map((data, index)=>{
                                                        return <li key={index} className="song-title">
                                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </li>
                                            <li className="song-title">
                                                <img src={this.state.musicTracks.track_3_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title">{this.state.musicTracks.track_3_desc.itemLabel}</a>
                                                <ul>
                                                    {this.state.musicTracksPlayable_3.map((data, index)=>{
                                                        return <li key={index} className="song-title">
                                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </li>
                                            <li className="song-title">
                                                <img src={this.state.musicTracks.track_4_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title">{this.state.musicTracks.track_4_desc.itemLabel}</a>
                                                <ul>
                                                    {this.state.musicTracksPlayable_4.map((data, index)=>{
                                                        return <li key={index} className="song-title">
                                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </li>
                                            <li className="song-title">
                                                <img src={this.state.musicTracks.track_5_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title">{this.state.musicTracks.track_5_desc.itemLabel}</a>
                                                <ul>
                                                    {this.state.musicTracksPlayable_5.map((data, index)=>{
                                                        return <li key={index} className="song-title">
                                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </li>
                                            <li className="song-title">
                                                <img src={this.state.musicTracks.track_5_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title">{this.state.musicTracks.track_5_desc.itemLabel}</a>
                                                <ul>
                                                    {this.state.musicTracksPlayable_5.map((data, index)=>{
                                                        return <li key={index} className="song-title">
                                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </li>
                                            <li className="song-title">
                                                <img src={this.state.musicTracks.track_6_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title">{this.state.musicTracks.track_6_desc.itemLabel}</a>
                                                <ul>
                                                    {this.state.musicTracksPlayable_6.map((data, index)=>{
                                                        return <li key={index} className="song-title">
                                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </li>
                                            <li className="song-title">
                                                <img src={this.state.musicTracks.track_7_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title">{this.state.musicTracks.track_7_desc.itemLabel}</a>
                                                <ul>
                                                    {this.state.musicTracksPlayable_7.map((data, index)=>{
                                                        return <li key={index} className="song-title">
                                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </li>
                                            <li className="song-title">
                                                <img src={this.state.musicTracks.track_8_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title">{this.state.musicTracks.track_8_desc.itemLabel}</a>
                                                <ul>
                                                    {this.state.musicTracksPlayable_8.map((data, index)=>{
                                                        return <li key={index} className="song-title">
                                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </li>
                                            <li className="song-title">
                                                <img src={this.state.musicTracks.track_9_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title">{this.state.musicTracks.track_9_desc.itemLabel}</a>
                                                <ul>
                                                    {this.state.musicTracksPlayable_9.map((data, index)=>{
                                                        return <li key={index} className="song-title">
                                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </li>
                                            <li className="song-title">
                                                <img src={this.state.musicTracks.track_10_desc.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                <a className="title">{this.state.musicTracks.track_10_desc.itemLabel}</a>
                                                <ul>
                                                    {this.state.musicTracksPlayable_10.map((data, index)=>{
                                                        return <li key={index} className="song-title">
                                                            <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                            <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                                        </li>
                                                    })}
                                                </ul>
                                            </li>
                                            
                                        </ul>
                                    </div>
                                    <hr/>
                                    <div className="top-songs">
                                        <h3 className="heading">{this.state.itemDescriptions.label_4_desc.itemLabel}</h3>
                                        <hr/>
                                        <ul>
                                            {this.state.musicGenres.map((data, index)=>{
                                                return <li key={index} className="song-title">
                                                    <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                                    <a className="title">{data.itemLabel}</a>
                                                </li>
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            )
                        }
                        <PlaySongs
                            music={this.state.selectedMusic}
                        />
                    </div>
                </div>
            </>
        )
    }
}

export default MyMusic;
